<script setup lang="ts">
/* eslint-env vue/setup-compiler-macros */
import type { Component } from 'vue';

defineProps<{
    title: string
    icon?: Component
}>();
</script>

<template>
    <section class="page-view" :aria-label="title">
        <!-- PHASE1: Comment this opening tag and uncomment the PHASE2 tag to restore default alignment. -->
        <header
            class="page-view__header"
            :class="{ 'page-view__header--phase1-with-actions': $slots.actions }"
        >
            <!-- PHASE2: <header class="page-view__header"> -->
            <div class="page-view__headline">
                <component
                    v-if="icon"
                    :is="icon"
                    class="page-view__icon"
                    aria-hidden="true"
                />
                <h1 class="page-view__title">{{ title }}</h1>
            </div>

            <div v-if="$slots.actions" class="page-view__toolbar">
                <div class="page-view__actions">
                    <slot name="actions" />
                </div>
            </div>
        </header>

        <div class="page-view__body">
            <slot />
        </div>
    </section>
</template>

<style lang="scss" scoped>
.page-view {
    &__header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 24px;
    }

    // PHASE1: Place actions 30px below navigation while keeping the title aligned with other views.
    &__header--phase1-with-actions {
        align-items: center;
        margin-top: -10px;
    }

    &__toolbar {
        flex-shrink: 0;
    }

    &__headline {
        display: flex;
        align-items: center;
        gap: 12px;
        padding-left: 35px;
    }

    &__icon {
        display: block;
        color: $main-orange;
    }

    &__title {
        font-family: $font-family-archivo;
        font-size: 24px;
        font-weight: 600;
        line-height: 1;
        color: $color-text-primary;
    }

    &__body {
        margin-top: 30px;
    }
}
</style>
